import { useTranslation } from 'react-i18next'

import { TableCellBase } from '../../Table'
import { TaskStatusType } from '../Task.enums'
import { TaskStatusToggle } from '../TaskStatusToggle'

function TaskTableRowDoneStatus({
  disabled,
  isLoading,
  item,
  onChange,
  ...restProps
}) {
  const { done } = item

  const { t } = useTranslation()

  function handleChange() {
    onChange?.({ done: !done })
  }

  return (
    <TableCellBase {...restProps}>
      <TaskStatusToggle
        checked={done}
        disabled={disabled}
        isLoading={isLoading}
        text={t(done ? 'TaskTable.StatusDoneKey' : 'TaskTable.StatusOpenKey')}
        tooltip={t(
          done
            ? 'TaskTable.ActionMarkAsOpenTooltipKey'
            : 'TaskTable.ActionMarkAsDoneTooltipKey'
        )}
        type={TaskStatusType.Done}
        onChange={handleChange}
      />
    </TableCellBase>
  )
}

export default TaskTableRowDoneStatus
